// Import Core
import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
// Import Components
import { Button } from './Button';
// Import Icons
import {
	FacebookShareButton,
	FacebookIcon,
	LinkedinShareButton,
	LinkedinIcon,
	TwitterShareButton,
	TwitterIcon,
	WhatsappShareButton,
	WhatsappIcon,
	RedditShareButton,
	RedditIcon,
} from 'react-share';
// Import Utils
import { getSlug } from '../../utils/getSlug';

/* Styled Components */
const SocialPopupStyles = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	.title {
		margin-bottom: 24px;
	}
	.popup_inner {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		gap: 16px;
		align-items: center;
		.social-buttons {
			display: flex;
			flex-wrap: wrap;
			gap: 16px;
		}
		button {
			width: fit-content;
		}
	}
`;

/* Render Component */
const SocialPopup = ({ data }) => {
	const query = useStaticQuery(graphql`
  query {
    site {
			siteMetadata {
				siteUrl
			}
		}
  }
`);
	//For the social share buttons
	const title = `Read ${data.name} `;
	const url = `${query.site.siteMetadata.siteUrl}/${getSlug(data)}`;

	return (
		<SocialPopupStyles>
			<h3 className='title'>Share this hotel</h3>
			<div className='popup_inner'>
				<div className='social-buttons'>
					<FacebookShareButton url={url}>
						<FacebookIcon size={40} round={true} />
					</FacebookShareButton>

					{/* FOLLOW UP: TEST THESE WORK!!!! */}
					<TwitterShareButton
						url={url}
						title={title}
						// via={twitterHandle}
						// hashtags={tags}
					>
						<TwitterIcon size={40} round={true} />
					</TwitterShareButton>

					<LinkedinShareButton url={url}>
						<LinkedinIcon size={40} round={true} />
					</LinkedinShareButton>

					<RedditShareButton url={url} title={title}>
						<RedditIcon size={40} round={true} />
					</RedditShareButton>

					<WhatsappShareButton url={url} title={title}>
						<WhatsappIcon size={40} round={true} />
					</WhatsappShareButton>
				</div>

				<Button
					onClick={() => {
						navigator.clipboard.writeText(url);
					}}>
					Copy Link
				</Button>
			</div>
		</SocialPopupStyles>
	);
};

export default SocialPopup;
